export default "<app-login-component>   </app-login-component>\n  \n";